import { render, staticRenderFns } from "./IndividualDocInfoPanel.vue?vue&type=template&id=5643cd8a&scoped=true&"
import script from "./IndividualDocInfoPanel.js?vue&type=script&lang=js&"
export * from "./IndividualDocInfoPanel.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5643cd8a",
  null
  
)

export default component.exports